export default {
    tags: [],
    metadata_file: '',
    name: '',
    description: '',
    pack: 't20_customer',
    type: {
        ref: 'standard',
        parameters: {
        // org: 'asdf1234'
        }
    },
    trigger: {
        type: 'core.st2.webhook',
        parameters: {
            url: '/t20'
        },
        ref: 'core.fd4dfd09-1d96-4cec-a905-66125a19a748'
    },
    criteria: {
        'trigger.body.data.eventName': {
            type: 'equals',
            // pattern: 'cameras/cameraSnapshot'
        }
    },
    action: {
        ref: 'st2_t20.',
        // parameters: {
        //   action: 'setCloudOn',
        //   equipmentId: '5b2d4321798fed8c01eac7c2'
        // }
    },
    context: {
        user: 'st2admin'
    },
    enabled: true
};
